module.exports = __webpack_public_path__ + "static/media/delivery.afe51761.svg";